import { render, staticRenderFns } from "./VTerminations.vue?vue&type=template&id=2609c90e&"
import script from "./VTerminations.vue?vue&type=script&lang=js&"
export * from "./VTerminations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports